import classnames from "classnames";
import styles from "./styles/library.module.scss";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import EmptyLibrary from "./EmptyLibrary";
import StoryCard from "./StoryCard";

const StoryGroup = ({
  books,
  orientation = "portrait",
  scrollable,
  ...props
}) => {
  if (props.hidden) return null;

  return (
    <Box
      className={classnames(styles.root, { [styles.scrollable]: scrollable })}
    >
      <Box
        className={classnames(styles.library, styles[orientation], {
          [styles.empty]: books.length === 0,
        })}
      >
        {books.map((story, index) => (
          <StoryCard key={index} {...story} orientation={orientation} />
        ))}
        <EmptyLibrary {...props} target={books} />
      </Box>
    </Box>
  );
};

StoryGroup.propTypes = {
  books: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      cover: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      file: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      translate: PropTypes.string,
      year: PropTypes.number.isRequired,
    })
  ),
  hidden: PropTypes.bool,
  orientation: PropTypes.oneOf(["portrait", "landscape"]),
  scrollable: PropTypes.bool,
};

export default StoryGroup;
